import * as WebFont from "webfontloader";

WebFont.load({
  google: {
    families: [
      "Nunito Sans:100,300,400,600,700",
      "Poppins:100,300,400,600,700",
    ],
  },
});
